export default __webpack_public_path__ + "static/media/sales_img.129720f1.svg";